<script setup lang="ts">
import InitializationWizard from '@/components/initialization-wizard.vue';
import { resetWizardDismissal } from '@/composables/use-initialization-wizard';

const externalUrl = 'https://heuriqa.byrnu.com/boards/parcours';

const openWizard = () => {
  resetWizardDismissal()
};
</script>

<template>
  <v-list class="py-0">
    <v-list-item :href="externalUrl" target="_blank" rel="noopener" color="primary" rounded="0">
      <template v-slot:prepend>
        <v-icon size="small">fas fa-lightbulb</v-icon>
      </template>
      <v-list-item-title class="text-body-2">Suggestions et idées</v-list-item-title>
    </v-list-item>

    <v-list-item color="primary" rounded="0" @click="openWizard">
      <template v-slot:prepend>
        <v-icon size="small">fas fa-clipboard-list</v-icon>
      </template>
      <v-list-item-title class="text-body-2">Assistant de configuration initiale</v-list-item-title>
    </v-list-item>
  </v-list>
</template>
